import { ReactNode } from "react";

import {
  BulkActionActionConfirmationTabs,
  BulkActionItemID,
  BulkActionsStep,
  BulkActionsVariant,
} from "components/BulkActions/types";
import BulkActionsDrawerActionStepsFooter from "components/BulkActions/Drawer/ActionSteps/Footer";
import BulkActionsDrawerActionStepsConfirmation from "components/BulkActions/Drawer/ActionSteps/Confirmation";
import BulkActionsDrawerActionStepsConfirmationEmptyTab from "components/BulkActions/Drawer/ActionSteps/Confirmation/EmptyTab";

import { UserViewBinding } from "../../types";
import UserRolesBulkActionsSelectedItem from "./SelectedRoleItem";
import UserRolesBulkActionsConfirmActionForm from "./ConfirmActionForm";
import { UserRolesBulkActionsAnalyticsPayload, UserRolesBulkActionsSelectedAction } from "./types";
import { UserRolesMutationVariables } from "./useUserRolesBulkActions/types";

type UserRolesBulkActionsConfirmationViewProps = {
  applicableItems: UserViewBinding[];
  skippedItems: UserViewBinding[];
  onItemDismiss: (id: BulkActionItemID) => void;
  selectedBulkAction: UserRolesBulkActionsSelectedAction;
  onConfirm: (
    mutationVariables: UserRolesMutationVariables,
    analyticsPayload: UserRolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
  customConfirmationMessage?: ReactNode;
};

const UserRolesBulkActionsConfirmationView = ({
  applicableItems,
  skippedItems,
  onItemDismiss,
  selectedBulkAction,
  onConfirm,
  onCancel,
  customConfirmationMessage,
}: UserRolesBulkActionsConfirmationViewProps) => {
  const getItems = (tab: BulkActionActionConfirmationTabs) => {
    if (tab === BulkActionActionConfirmationTabs.Applicable) {
      return applicableItems;
    }

    return skippedItems;
  };

  return (
    <>
      <BulkActionsDrawerActionStepsConfirmation
        applicableCount={applicableItems.length}
        skippedCount={skippedItems.length}
      >
        {({ currentTab }) =>
          getItems(currentTab).length === 0 ? (
            <BulkActionsDrawerActionStepsConfirmationEmptyTab currentTab={currentTab} />
          ) : (
            getItems(currentTab).map((item) => (
              <UserRolesBulkActionsSelectedItem
                key={item.id}
                item={item}
                onDismiss={onItemDismiss}
                itemCategory={currentTab}
                step={BulkActionsStep.ActionConfirmation}
              />
            ))
          )
        }
      </BulkActionsDrawerActionStepsConfirmation>

      <BulkActionsDrawerActionStepsFooter>
        <UserRolesBulkActionsConfirmActionForm
          variant={BulkActionsVariant.Drawer}
          action={selectedBulkAction}
          onConfirm={onConfirm}
          onCancel={onCancel}
          customConfirmationMessage={customConfirmationMessage}
        />
      </BulkActionsDrawerActionStepsFooter>
    </>
  );
};

export default UserRolesBulkActionsConfirmationView;
